module.exports = __webpack_public_path__ + "static/img/jiazhi.c3dee55b.png";